import type { HttpClient } from './http-client.js';
import type { AdminGame, AdminHealth, AdminSessionInspection, GameStatus } from './types.js';

interface GamesEnvelope {
  games: AdminGame[];
}

interface GameEnvelope {
  game: AdminGame;
}

interface HealthEnvelope {
  health: AdminHealth;
}

interface InspectionEnvelope {
  inspection: AdminSessionInspection;
}

export interface AdminApi {
  listGames(): Promise<AdminGame[]>;
  setGameStatus(gameId: string, status: GameStatus): Promise<AdminGame>;
  health(): Promise<AdminHealth>;
  inspectSession(sessionId: string): Promise<AdminSessionInspection>;
}

export function createAdminApi(http: HttpClient): AdminApi {
  return {
    async listGames() {
      const { games } = await http.request<GamesEnvelope>({ method: 'GET', path: '/admin/games' });
      return games;
    },
    async setGameStatus(gameId, status) {
      const { game } = await http.request<GameEnvelope>({
        method: 'PATCH',
        path: `/admin/games/${encodeURIComponent(gameId)}`,
        body: { status },
      });
      return game;
    },
    async health() {
      const { health } = await http.request<HealthEnvelope>({
        method: 'GET',
        path: '/admin/health',
      });
      return health;
    },
    async inspectSession(sessionId) {
      const { inspection } = await http.request<InspectionEnvelope>({
        method: 'GET',
        path: `/admin/sessions/${encodeURIComponent(sessionId)}`,
      });
      return inspection;
    },
  };
}
